import React from 'react';
import { PropInfo, CodeExample, DropdownProps } from '@cimpress/react-components';

import DropdownCode from '!raw-loader!./dropdown.jsx';
import DropdownDemo from './dropdown.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const DropdownDocs = () => {
  const propInfos: PropInfo<DropdownProps>[] = [
    {
      name: 'style',
      type: 'object',
      default: '',
      description: 'Inline styles to be applied to the root dropdown div.',
    },
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Additional class names to be applied to the dropdown btn-group.',
    },
    {
      name: 'variant',
      type: 'string',
      default: 'default',
      description: (
        <div>
          The variant of dropdown you are creating, providing one of the following values:
          <ul>
            <li>default</li>
            <li>simple</li>
            <li>navtab</li>
          </ul>
          If <code>navtab</code> is used, the <code>as</code> prop will be overridden to be a{' '}
          <code>{'<li> </li>'}</code> tag and the
          <code>innerAs</code> prop will be overridden to be a <code>{'<a> </a>'}</code> tag.
        </div>
      ),
    },
    {
      name: 'title',
      type: 'node',
      default: '',
      description: 'Title for the dropdown button.',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description:
        'Whether or not to disable the dropdown button.  If there are no children, the dropdown will be disabled by default.',
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: (
        <span>
          Items to display in the dropdown. These should probably be <code>&lt;a&gt;</code> or{' '}
          <code>&lt;button&gt;</code> elements. An <code>&lt;hr/&gt;</code> can be used to create a divider.
        </span>
      ),
    },
    {
      name: 'as',
      type: 'string',
      default: 'div',
      description: `What html tag to use as the root containing dom element.
    Will be set to a list item tag (<li> </li>) if using navtab type.`,
    },
  ];

  return (
    <ComponentDoc<DropdownProps> name="Dropdown" propInfos={propInfos}>
      <DropdownDemo />
      <CodeExample code={DropdownCode} />
    </ComponentDoc>
  );
};

export default DropdownDocs;
